import { useForm } from '@mantine/form';

import { MeasureSolutionResponseItem } from '@e-origin/contracts';

import { useCreateMeasureSolution, useEditMeasureSolution } from '@hooks/measure-solutions';

const HS_CODE_REGEX = /^\d{10}$/;

export type EditMeasureSolutionValues = Pick<MeasureSolutionResponseItem, 'hsCode' | 'origin' | 'measure' | 'group' | 'solution'>;

const buildInitialValues = (measureSolution?: MeasureSolutionResponseItem): EditMeasureSolutionValues => ({
  hsCode: measureSolution?.hsCode || '',
  origin: measureSolution?.origin || '',
  measure: measureSolution?.measure || '',
  group: measureSolution?.group || '',
  solution: measureSolution?.solution || '',
});

export const useEditMeasureSolutionFormInitializer = (measureSolution?: MeasureSolutionResponseItem) => {
  const createMutation = useCreateMeasureSolution();
  const editMutation = useEditMeasureSolution();

  const form = useForm<EditMeasureSolutionValues>({
    initialValues: buildInitialValues(measureSolution),
    validate: {
      hsCode: (value) => (HS_CODE_REGEX.test(value ?? '') ? null : 'HS code must have 10 digits'),
    },
    validateInputOnBlur: true,
  });

  const onSubmit = async (values: EditMeasureSolutionValues) => {
    if (measureSolution?._id) {
      return editMutation.mutateAsync({ id: String(measureSolution._id), ...values });
    }
    return createMutation.mutateAsync(values);
  };

  return {
    form,
    onSubmit,
    isSubmitting: createMutation.isPending || editMutation.isPending,
  };
};
